import { render, staticRenderFns } from "./ActivationDeliverableContentApprovalView.vue?vue&type=template&id=2dfa75a1&scoped=true&"
import script from "./ActivationDeliverableContentApprovalView.vue?vue&type=script&lang=js&"
export * from "./ActivationDeliverableContentApprovalView.vue?vue&type=script&lang=js&"
import style0 from "./ActivationDeliverableContentApprovalView.vue?vue&type=style&index=0&id=2dfa75a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa75a1",
  null
  
)

export default component.exports